import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const DICT = {
  it: {
    "nav.vetrina": "Vetrina",
    "nav.artisti": "Artisti",
    "nav.spettacoli": "Spettacoli",
    "nav.richiedi": "Il mio evento",
    "nav.chisiamo": "Chi siamo",
    "nav.servizi": "Servizi",
    "nav.candidati": "Candidati",
    "nav.mierichieste": "Le mie richieste",
    "nav.areagestione": "Area gestione",
    "nav.esci": "Esci",

    "hero.eyebrow": "Vetrina proposte artistiche",
    "hero.title": "Artisti e {italic1} per la tua {italic2}.",
    "hero.italic1": "spettacoli",
    "hero.italic2": "piazza",
    "hero.subtitle":
      "Un archivio curato di proposte pronte per enti, comuni, associazioni e locali. Sfoglia il catalogo, scegli l'artista o lo spettacolo, richiedi la proposta su misura a NMA Agency con un click.",
    "hero.ctaArtists": "Esplora artisti",
    "hero.ctaShows": "Vedi gli spettacoli",

    "stats.title": "Ogni evento è una {italic}. Queste sono le nostre.",
    "stats.italic": "storia",
    "stats.eyebrow": "In numeri",
    "stats.events": "Eventi prodotti",
    "stats.cities": "Città toccate",
    "stats.artists": "Artisti in roster",
    "stats.shows": "Format spettacolo",

    "steps.eyebrow": "Come funziona",
    "steps.title": "Un click. {italic} pensa a tutto.",
    "steps.italic": "NMA",
    "steps.cta": "Richiedi un preventivo",

    "services.eyebrow": "Cosa fa NMA",
    "services.title": "Più di un booking: la nostra {italic} produttiva.",
    "services.italic": "casa",
    "services.subtitle":
      "Promozione radio · TV · stampa · web per artisti e aziende. Produzione di spot, jingle, videoclip, grafica, testi, musiche e canzoni. Sceneggiature e format originali per radio e TV.",
    "services.cta": "Scopri tutti i servizi",

    "apply.eyebrow": "Sei un artista?",
    "apply.title": "Candidati al {italic} NMA.",
    "apply.italic": "roster",
    "apply.subtitle":
      "Cerchiamo talenti confermati ed emergenti. Se hai una voce, un progetto o un'idea da mostrare al mondo, lasciacela sentire.",
    "apply.cta": "Invia la tua candidatura",

    "footer.rights": "Tutti i diritti riservati",
  },
  en: {
    "nav.vetrina": "Showcase",
    "nav.artisti": "Artists",
    "nav.spettacoli": "Shows",
    "nav.richiedi": "My event",
    "nav.chisiamo": "About",
    "nav.servizi": "Services",
    "nav.candidati": "Apply",
    "nav.mierichieste": "My requests",
    "nav.areagestione": "Back office",
    "nav.esci": "Sign out",

    "hero.eyebrow": "Curated performance showcase",
    "hero.title": "Artists and {italic1} for your {italic2}.",
    "hero.italic1": "shows",
    "hero.italic2": "stage",
    "hero.subtitle":
      "A curated archive of ready-to-go acts for municipalities, brands, venues and private hosts. Browse the catalogue, pick an artist or show, request a tailor-made quote from NMA Agency in one click.",
    "hero.ctaArtists": "Explore artists",
    "hero.ctaShows": "See shows",

    "stats.title": "Every event is a {italic}. These are ours.",
    "stats.italic": "story",
    "stats.eyebrow": "By the numbers",
    "stats.events": "Events produced",
    "stats.cities": "Cities reached",
    "stats.artists": "Artists on roster",
    "stats.shows": "Show formats",

    "steps.eyebrow": "How it works",
    "steps.title": "One click. {italic} handles it all.",
    "steps.italic": "NMA",
    "steps.cta": "Request a quote",

    "services.eyebrow": "What NMA does",
    "services.title": "More than booking: our creative {italic}.",
    "services.italic": "house",
    "services.subtitle":
      "Radio · TV · press · web promotion for artists and brands. We produce spots, jingles, music videos, graphics, lyrics, music and songs. Original scripts and formats for radio and TV.",
    "services.cta": "See all services",

    "apply.eyebrow": "Are you an artist?",
    "apply.title": "Apply to the NMA {italic}.",
    "apply.italic": "roster",
    "apply.subtitle":
      "We scout established and emerging talent. If you have a voice, a project or an idea worth sharing, send it over.",
    "apply.cta": "Send your application",

    "footer.rights": "All rights reserved",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("av_lang") || "it");
  useEffect(() => {
    localStorage.setItem("av_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback(
    (key) => (DICT[lang] && DICT[lang][key]) || DICT.it[key] || key,
    [lang]
  );
  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "it"), []);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export function useT() {
  return useContext(I18nCtx);
}
